var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 18,
    viewBox: "0 0 6 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fillDefault",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.103256 4.93784L2.35241 1.64778C2.62469 1.13568 3.27547 1.10556 3.59228 1.55741L5.89674 4.93784C6.1883 5.48618 5.82778 6.1748 5.24915 6.1748L0.750847 6.1748C0.172222 6.1748 -0.188296 5.48618 0.103256 4.93784Z",
    fill: "#6F7780"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fillDefault",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.89674 13.0137L3.64759 16.4269C3.37531 16.9582 2.72453 16.9894 2.40772 16.5207L0.103256 13.0137C-0.188296 12.4449 0.172221 11.7305 0.750847 11.7305L5.24915 11.7305C5.82778 11.7305 6.1883 12.4449 5.89674 13.0137Z",
    fill: "#6F7780"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "e0b00bf29706bd8b8c46e4bbee402b5d.svg";
export { ForwardRef as ReactComponent };